// Mobile Menu Toggler
var menu_toggle_button = document.getElementById('menu-toggler');
var menu_panel         = document.getElementById('menu-panel');
var overlay            = document.getElementById('overlay');
var level1_items       = document.querySelectorAll('.menu-level-1 > li');
var level2_items       = document.querySelectorAll('.menu-level-2 > li');
var level3_items       = document.querySelectorAll('.menu-level-3 > li');
var back_buttons       = document.querySelectorAll('.back-item');

/**
 * Get the closest matching element up the DOM tree.
 * @private
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 */
function getClosest( elem, selector ) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function(s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            };
    }

    // Get closest match
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if ( elem.matches( selector ) ) return elem;
    }

    return null;
};

if (menu_toggle_button) {

    menu_toggle_button.addEventListener('click', function(event){
        this.classList.toggle('open')
        overlay.classList.toggle('open')
        menu_panel.classList.toggle('open')
        document.documentElement.classList.toggle('no-scroll')
        document.body.classList.toggle('no-scroll')
    })

    overlay.addEventListener('click', function(event){
        menu_toggle_button.classList.toggle('open')
        menu_panel.classList.toggle('open')
        overlay.classList.toggle('open')
        document.documentElement.classList.toggle('no-scroll')
        document.body.classList.toggle('no-scroll')

        if (level1_items.length) {
            Array.prototype.forEach.call(level1_items, function(el, i){
                el.classList.remove('active')
            })
        }
    }, false)

    document.ontouchmove = function(e){
        if (document.documentElement.classList.contains('no-scroll') && document.body.classList.contains('no-scroll')) {
            e.preventDefault()
        } else {
            return true
        }
    }
}

function resetMenuStyle() {
    menu_toggle_button.classList.remove('open')
    menu_panel.classList.remove('open')
    overlay.classList.remove('open')
    document.documentElement.classList.remove('no-scroll')
    document.body.classList.remove('no-scroll')

    var $activeElements = document.getElementById('header').getElementsByClassName('active')
    Array.prototype.forEach.call($activeElements, function(el, i) {
        el.classList.remove('active')
    })

    document.ontouchmove = function(e) {
        return true
    }

    Array.prototype.forEach.call(back_buttons, function(el, i){
        el.removeEventListener('click', backItemsAction)
    });

    Array.prototype.forEach.call(level1_items, function(el, i){
        el.removeEventListener('click', levelItemsAction);
    });

    Array.prototype.forEach.call(level2_items, function(el, i){
        el.removeEventListener('click', levelItemsAction);
    });

    Array.prototype.forEach.call(level3_items, function(el, i){
        el.removeEventListener('click', levelItemsAction);
    });
}

function backItemsAction(event) {
    event.stopPropagation();
    var element = event.target
    getClosest(element,'.active').classList.remove('active');
}

function levelItemsAction (event) {
    event.stopPropagation();
    var element = event.target
    element.parentNode.classList.toggle('active');
}

function initMobileMenu() {
    if (menu_toggle_button) {
        if ( $(window).width() < 992 ) {
            Array.prototype.forEach.call(back_buttons, function(el, i){
                el.addEventListener('click', backItemsAction)
            });

            Array.prototype.forEach.call(level1_items, function(el, i){
                el.addEventListener('click', levelItemsAction);
            });

            Array.prototype.forEach.call(level2_items, function(el, i){
                el.addEventListener('click', levelItemsAction);
            });

            Array.prototype.forEach.call(level3_items, function(el, i){
                el.addEventListener('click', levelItemsAction);
            });
        } else {
            resetMenuStyle()
        }
    }
}

initMobileMenu()

window.addEventListener('resize', function(){
    initMobileMenu()
})

window.addEventListener('orientationchange', function(){
    initMobileMenu()
})
